import Cookies from 'cookies-js';

(function( $ ) {
	'use strict';

	// Stash the current URL as a cookie whenever our login link is clicked.
	$( '.intent-login' ).on ( 'click', function (e) {
		Cookies.set( 'yoko-sso-target-url', window.location.href, { expires: 86400 } );
	});
} ) ( jQuery );
